export const LOGGED_IN = 'LOGGED_IN';

export default { LOGGED_IN };
